import React from 'react';

export default function create() {
  return (
    <div>settings/create</div>
  );
}
